'use client';
import styles from './styles.module.css';
import Image from 'next/image';
import Modal from '../../../components/ui/Modal/Modal';

interface InTouchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function InTouchModal({ isOpen, onClose }: InTouchModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.modalContent}>
        <div className={styles.iconContainer}>
          <Image 
            src="/assets/icons/right.svg" 
            alt="Success" 
            width={100} 
            height={100}
            className={styles.successIcon}
          />
        </div>
        
        <div className={styles.messageContainer}>
          <h3 className={styles.modalTitle}>Спасибо! Заявка отправлена. Мы скоро с вами свяжемся</h3>
        </div>
        
        <button className={styles.continueButton} onClick={onClose}>
          Продолжить
        </button>
      </div>
    </Modal>
  );
} 